import type { StyleRow } from './stylesFixtureData';
import { stylesBulkEditProbes } from './stylesBulkEditProbeFixtureData';
import { stylesSelectionGatingFixtures } from './stylesSelectionGatingFixtureData';

/**
 * Registers the bulk-edit e2e fixture rows into the mock `stylesData` array — split out of
 * `styles.ts` to keep that handler under the 800-line cap (DL-62594). Returns `true` when the
 * array changed so the caller persists it exactly once.
 *
 * - **Probes** (DL-62593, field-availability) are seeded ONLY on a fresh build. Re-pushing the
 *   pristine probe rows onto an already-mutated restored array would duplicate every probe (a
 *   stale pre-mutation copy beside the real, updated one).
 * - **Selection-gating** rows (DL-66466, Testmo folder 93165 part 3 of 4) are seeded
 *   IDEMPOTENTLY via an id presence-check: present even when styles data is restored from a
 *   snapshot that predates them (e.g. a stale local Playwright auth snapshot — Greptile PR
 *   #15211), yet never duplicated on the in-test restore-after-mutation path the fresh gate
 *   guards for the probes.
 */
export const installStylesBulkEditFixtures = (
  stylesData: StyleRow[],
  builtStylesFresh: boolean
): boolean => {
  let changed = false;
  if (builtStylesFresh) {
    stylesData.push(...stylesBulkEditProbes);
    changed = true;
  }
  const gatingIds = new Set(stylesSelectionGatingFixtures.map(row => row.id));
  if (!stylesData.some(row => gatingIds.has(row.id))) {
    stylesData.push(...stylesSelectionGatingFixtures);
    changed = true;
  }
  return changed;
};
